import InstructorSelect from "./InstructorSelect";
export default InstructorSelect;
